<template>
    <div class="banner">
      <img src="../assets/images/banner.jpg">
    </div>
</template>

<script>
export default {
  name: 'Banner'
}
</script>

<style scoped lang="stylus">
  .banner
    img
      width: 100%
</style>



// WEBPACK FOOTER //
// src/components/Banner.vue